import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import { SaktiPushOdooJob, SaktiPushOdooRequest } from '../types';

/**
 * Client for the Push-to-Odoo re-sync gateway (`/api/sakti/push-odoo/*`), which
 * enqueues a Celery job and reports its status. The job forwards the request to
 * Sakti Go's odoo-worker; `getPushJob` returns the PushResult once state is SUCCESS.
 */
export class SaktiPushOdooApiService {
  // POST /jobs — enqueue a re-sync. Returns {task_id, state} immediately (HTTP 202).
  static async startPushJob(payload: SaktiPushOdooRequest): Promise<SaktiPushOdooJob> {
    const response = await api.post<SaktiPushOdooJob>(
      SAKTI_API_CONFIG.PUSH_ODOO_JOBS_PATH,
      payload
    );

    return response.data;
  }

  // GET /jobs/{task_id} — poll job state; `result` holds the PushResult on SUCCESS.
  static async getPushJob(taskId: string): Promise<SaktiPushOdooJob> {
    const response = await api.get<SaktiPushOdooJob>(
      SAKTI_API_CONFIG.PUSH_ODOO_JOB_STATUS_PATH(taskId)
    );

    return response.data;
  }
}

export default SaktiPushOdooApiService;
